import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import { useStaticQuery, graphql } from "gatsby"

import { trackDataLayerEvent } from "@utils/trackDataLayerEvent"

import { useHubspotForm } from "@hooks/useHubspotForm"

export default () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  const { allCountryList } = useStaticQuery(graphql`
    query {
      allCountryList {
        nodes {
          en
          de
          es
        }
      }
    }
  `)

  function getSortedArrayByLanguage(data, language) {
    const transformedArray = data.map(item => {
      return {
        value: item[language],
        label: item[language],
        en: item.en,
      }
    })

    transformedArray.sort((a, b) => a.value.localeCompare(b.value))

    const orderedArr = [
      ...transformedArray.filter(obj => obj.en === "Austria"),
      ...transformedArray.filter(obj => obj.en === "Germany"),
      ...transformedArray.filter(obj => obj.en === "Switzerland"),
      ...transformedArray.filter(obj => obj.en === "Spain"),

      ...transformedArray.filter(
        obj => !["Austria", "Germany", "Spain", "Switzerland"].includes(obj.en)
      ),
    ]

    return orderedArr
  }
  const handleClick = () => {
    try {
      trackDataLayerEvent({
        id: "Contact Form Submitted",
        triggers: "Send",
        source: "ContactUs",
      })
    } catch (Any) {
      console.log(Any)
    }
  }

  useHubspotForm({
    portalId: "25964422",
    formId: "00168e58-f23b-4aa0-bfac-94bea56effd9",
    target: "#hubspotForm",
    locale: language,
    groupErrors: false,
    formInstanceId: "contact_us_main_form_id",

    onFormReady: function ($form, $message) {
      const generateDropdown = (selector, data, separator) => {
        let dropdown = $form.querySelector(selector)
        while (dropdown.firstChild) {
          dropdown.removeChild(dropdown.firstChild)
        }
        let firstOption = document.createElement("option")
        firstOption.value = t("reason_please_select")
        firstOption.text = t("reason_please_select")
        firstOption.disabled = true
        firstOption.selected = true
        dropdown.appendChild(firstOption)

        data.forEach(function (item, index) {
          if (index === separator) {
            let separatorOption = document.createElement("option")
            separatorOption.value = ""
            separatorOption.text = ""
            separatorOption.disabled = true
            separatorOption.selected = false
            dropdown.appendChild(separatorOption)
          }

          let option = document.createElement("option")
          option.value = item.value
          option.text = item.label

          dropdown.appendChild(option)
        })
      }

      const allCountryListByLanguage = getSortedArrayByLanguage(
        allCountryList.nodes,
        language
      )

      generateDropdown(
        'select[name="country_region"]',
        allCountryListByLanguage,
        4
      )
      const countryDropdown = [
        { value: t("reason_account"), label: t("reason_account") },
        { value: t("reason_order"), label: t("reason_order") },
        { value: t("reason_transaction"), label: t("reason_transaction") },
        { value: t("reason_buying"), label: t("reason_buying") },
        { value: t("reason_financing"), label: t("reason_financing") },
        { value: t("reason_logistics"), label: t("reason_logistics") },
        { value: t("resason_others"), label: t("resason_others") },
      ]
      generateDropdown('select[name="reason"]', countryDropdown)

      let hs_language = $form.querySelector('input[name="hs_language"]')

      if (hs_language) {
        hs_language.value = language
      }
      const selector = $form.querySelector("[name='reason']")
      if (selector) {
        const previousElem = document.querySelector(".hs_reason")
        const divElement = document.createElement("div")
        divElement.hidden = true
        if (previousElem) {
          previousElem.after(divElement)
        }

        selector.addEventListener("change", e => {
          const selectedValue = e.target.selectedOptions[0].value
          if (
            selectedValue === "Buying metal scrap inquiry" ||
            selectedValue === "Consulta para comprar chatarra" ||
            selectedValue === "Anfrage zum Kauf von Metallschrott"
          ) {
            divElement.innerHTML = t("Contact_Us_Buying_Scrap_Metals_Message")
            divElement.hidden = false
          } else {
            divElement.hidden = true
          }
        })
      }
    },

    onSubmitted() {
      handleClick()
    },

    translations: {
      [language]: {
        submitText: t("Contact_Button_Send"),
        fieldLabels: {
          firstname: t("Contact_FirstName"),
          lastname: t("Contact_LastName"),
          company: t("Contact_Company"),
          email: t("Contact_Email"),
          mobilephone: t("Contact_Phone"),
          country_region: t("Contact_Country"),
          reason: t("Contact_Topic"),
          message: t("Contact_FreeText"),
          hs_language: t("Contact_PreferredLanguage"),
        },
      },
    },
  })

  return (
    <section className="bg-lblue xl:pt-[69px] xl:pb-[26px]">
      <div className="flex flex-col xl:flex-row items-center xl:items-start max-w-[960px] m-auto bg-white py-10 px-6 md:py-10 md:px-11 xl:p-20">
        <div className="flex-grow">
          <h1 className="text-dblue font-inter text-20 xl:text-40 font-medium leading-normal mb-3 xl:mb-6">
            {t("Footer_Contact_us")}
          </h1>
          <div id="hubspotForm" className="hubspotForm"></div>
        </div>
      </div>
      {/* Adress at the bottom: */}
      <div className="flex justify-center xl:justify-start bg-white md:bg-lblue py-15 w-full ">
        <div className="flex-grow max-w-[960px] px-6 md:px-11 xl:px-20 m-auto">
          <p className="text-xl font-inter font-medium">
            {t("PrivacyPolicy_Header5")}
          </p>
          <p className="text-base text-[#5B5866] font-inter">
            {t("PrivacyPolicy_Paragraph5")}
          </p>
        </div>
      </div>
    </section>
  )
}
